import React from 'react';
import PropTypes from 'prop-types';

function CheckoutColor(props) {
    const { color, colorPos } = props;
    let copy = props.copy;
    const r = `0${color.r.toString(16)}`;
    const g = `0${color.g.toString(16)}`;
    const b = `0${color.b.toString(16)}`;
    const sColor = `#${r.slice(-2)}${g.slice(-2)}${b.slice(-2)}`;

    const { pantone } = color;
    const hasPantoneColor = typeof pantone === 'string' && pantone.length;
    if (!copy) {
        copy = [sColor];
    }

    return (
        <div className="checkout__color">
            <span className="checkout__color--inner">
                <span className="checkout__color--color">
                    <div
                        style={{ background: sColor }}
                        className={sColor === '#ffffff' ? 'is-white' : ''}
                    />
                </span>
                <span className="checkout__color--info">
                    {copy.map((line, index) => {
                        const colorName = hasPantoneColor ? pantone : sColor;

                        return <p key={index}>{index === colorPos ? colorName : line}</p>;
                    })}
                </span>
            </span>
        </div>
    );
}

CheckoutColor.propTypes = {
    color: PropTypes.object.isRequired,
    copy: PropTypes.array,
    colorPos: PropTypes.number,
};

export default CheckoutColor;
